<template>
    <div>
        <div class="space-y-12 mt-0">
            <div v-for="preliminaryGroup in preliminaries">
                <table class="w-full font-semibold text-gray-700" :style="'background-color: '+preliminaryGroup.color">
                    <tbody>
                    <tr>
                        <td class="pl-2 py-2" width="70">{{ preliminaryGroup.reference }}</td>
                        <td>{{ preliminaryGroup.name }}</td>
                    </tr>
                    </tbody>
                </table>
                <table class="w-full mt-0 text-gray-600">
                    <thead class="bg-gray-100">
                    <tr class="hidden md:table-row">
                        <th class="text-left text-sm font-semibold text-gray-500 py-1 pl-2" width="70">Ref</th>
                        <th class="text-left text-sm font-semibold text-gray-500 py-1">Description</th>
                        <th class="text-right text-sm font-semibold text-gray-500 py-1" width="80" v-if="!estimate.hideItemCostings">Qty</th>
                        <th class="text-right text-sm font-semibold text-gray-500 py-1" width="80" v-if="!estimate.hideItemCostings">UoM</th>
                        <th class="text-right text-sm font-semibold text-gray-500 py-1" width="120" v-if="!estimate.hideItemCostings">Rate</th>
                        <th class="text-right text-sm font-semibold text-gray-500 py-1 pr-2" width="140" v-if="!estimate.hideItemCostings">Net</th>
                    </tr>
                    <tr class="md:hidden">
                        <th class="text-left text-sm font-semibold text-gray-500 py-1 pl-2">Description</th>
                        <th class="text-right text-sm font-semibold text-gray-500 py-1 pr-2" width="140" v-if="!estimate.hideItemCostings">Net Amount</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="item in preliminaryGroup.items">
                        <!----Desktop.-- -->
                        <tr class="hidden md:table-row" :style="'background-color: '+item.color">
                            <td class="align-top text-left py-2 pl-2 border border-gray-200"
                                :rowspan="1">{{
                                    item.reference
                                }}
                            </td>
                            <td class="align-top text-left py-2 whitespace-pre-wrap pl-2 border border-gray-200"
                                v-text="item.description">
                            </td>
                            <td class="align-top text-right py-2 pr-2 border border-gray-200" v-if="!estimate.hideItemCostings">{{ item.quantity }}</td>
                            <td class="align-top text-right py-2 pr-2 border border-gray-200" v-if="!estimate.hideItemCostings">{{ item.uom }}</td>
                            <td class="align-top text-right py-2 pr-2 border border-gray-200" v-if="!estimate.hideItemCostings">{{ item.rate | toCurrency }}</td>
                            <td class="align-top text-right py-2 pr-2 border border-gray-200" v-if="!estimate.hideItemCostings">{{ item.total | toCurrency }}
                            </td>
                        </tr>
                        <!----Mobile.-- -->
                        <tr class="md:hidden" :style="'background-color: '+item.color">
                            <td class="align-top text-sm sm:text-base px-2 pt-3 pb-0.5 pr-2 border border-gray-200" colspan="2">
                                <div class="flex items-start justify-between space-x-4">
                                    <div>
                                        <strong>{{ item.reference }}</strong>
                                        <p class="mt-1 whitespace-pre-wrap" v-text="item.description"></p>
                                    </div>
                                    <div class="text-right" v-if="!estimate.hideItemCostings">
                                        {{ item.total | toCurrency }}
                                    </div>
                                </div>
                                <p class="mt-1" v-if="!estimate.hideItemCostings">
                                    {{ item.quantity }} {{ item.uom }} x {{ item.rate | toCurrency }}
                                </p>
                            </td>
                        </tr>
                    </template>
                    <tr class="hidden md:table-row border-t text-sm font-semibold text-gray-500">
                        <td class="align-top text-right py-1 pl-2" :colspan="!estimate.hideItemCostings?5:1">Total</td>
                        <td class="align-top text-right py-1 pr-2">
                            {{
                                preliminaryGroup.total | toCurrency
                            }}
                        </td>
                    </tr>
                    <tr class="md:hidden border-t text-sm font-semibold text-gray-500">
                        <td class="align-top p-2 text-sm font-semibold text-gray-500" :colspan="!estimate.hideItemCostings?4:1">
                            <div class="flex items-start justify-between space-x-4">
                                <p>Total</p>
                                <p>{{
                                        preliminaryGroup.total | toCurrency
                                    }}</p>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {},
    props: {
        preliminaries: Array,
        estimate: Object,
    },
    data() {
        return {
        }
    },
    computed: {},
    methods: {},
    async mounted() {
    },
}
</script>
